var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"btn"},[_c('van-button',{staticStyle:{"width":"282px"},attrs:{"plain":"","color":"#1E8DFF"},on:{"click":_vm.handlePayAgain}},[_vm._v(" 再次购买 ")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('i',{staticClass:"iconfont iconicon_error"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('h4',[_vm._v(" 支付失败 "),_c('small',[_vm._v("再试一次")])])
}]

export { render, staticRenderFns }